import {
  GetAllReportsResponse,
  GetPublishedReportsResponse,
  GetPublishedTemplateReportsResponse,
  CreateTemplateReportResponse,
  ApiEnveloppe,
  CreateReportResponse,
  GenerateReportClientSideResponse,
} from '../../types/types';
import { axios, _post, requestType, setUrlPathFromDomain } from './_internal';

export const getPublishedReports = (payload: {
  list_project_id: any;
}): Promise<GetPublishedReportsResponse> => {
  return _post({
    request_type: requestType.recuperer_la_liste_des_rapports_publies,
    list_project_id: payload.list_project_id,
  });
};

export const getPublishedTemplateReports = (payload: {
  list_project_id: any;
}): Promise<GetPublishedTemplateReportsResponse> => {
  return _post({
    request_type: requestType.recuperer_la_liste_des_rapports_gabarits,
    list_project_id: payload.list_project_id,
  });
};

export const createTemplateReport = (
  payload: any
): Promise<CreateTemplateReportResponse> => {
  return _post({
    request_type: requestType.creer_un_rapport_gabarit,
    ...payload,
  });
};

export const updateTemplateReport = (payload: any) => {
  return _post({
    request_type: requestType.modifier_un_rapport_gabarit,
    ...payload,
  });
};

export const deleteTemplateReport = (payload: {
  template_report_id: string;
}): Promise<ApiEnveloppe> => {
  return _post({
    request_type: requestType.supprimer_un_rapport_gabarit,
    template_report_id: payload.template_report_id,
  });
};

export const createReport = (payload: {
  template_report_id: string;
  start_report: any;
  end_report: any;
}): Promise<CreateReportResponse> => {
  return _post({
    request_type: requestType.generer_un_rapport,
    template_report_id: payload.template_report_id,
    start_report: payload.start_report,
    end_report: payload.end_report,
  });
};

export const getAllReports = (payload: {
  list_project_id: any;
  start_list_generate_report: any;
  end_list_generate_report: any;
}): Promise<GetAllReportsResponse> => {
  return _post({
    request_type: requestType.recuperer_la_liste_des_rapports_generes,
    list_project_id: payload.list_project_id,
    start_list_generate_report: payload.start_list_generate_report,
    end_list_generate_report: payload.end_list_generate_report,
  });
};

//TODO missing response from api for this call
export const publishReports = (payload: { generate_report_id: any }) => {
  return _post({
    request_type: requestType.publier_un_rapport_genere,
    generate_report_id: payload.generate_report_id,
  });
};

//TODO response is "Le rapport a été supprimé avec succès." sans formattage
export const deleteReports = (payload: { generate_report_id: string }) => {
  return _post({
    request_type: requestType.supprimer_un_rapport_genere,
    generate_report_id: payload.generate_report_id,
  });
};

export const getTemplateReportConfig = async (payload: {
  path_config: string;
}) => {
  const baseUrl = setUrlPathFromDomain(
    'http://localhost:4000',
    'https://argos-v19.itmsol.fr',
    'https://argos-v25.itmsol.fr',
    'https://argos-dev.itmsol.fr'
  );

  let origin = 'https://argos-v19.itmsol.fr';
  try {
    origin = new URL(baseUrl).origin;
  } catch (error) {
    origin = 'https://argos-v19.itmsol.fr';
  }

  const rawPath =
    typeof payload?.path_config === 'string' ? payload.path_config.trim() : '';
  if (!rawPath) {
    throw new Error('path_config is empty');
  }

  let url = '';
  try {
    const absoluteUrl = new URL(rawPath);
    if (absoluteUrl.hostname === 'localhost') {
      url =
        origin +
        absoluteUrl.pathname +
        (absoluteUrl.search || '') +
        (absoluteUrl.hash || '');
    } else {
      url = rawPath;
    }
  } catch (error) {
    if (rawPath.startsWith('/')) {
      url = origin + rawPath;
    } else {
      url = origin + '/' + rawPath;
    }
  }

  return axios.get(url, {
    headers: { 'Content-Type': 'application/json' },
    params: { varget0: Math.random() },
  });
};

// TODO error :
//  <br/><b>Warning</b>:
//    unlink(/ var/ www/ dashboard_export/ 1789131275899_126398/ 1789131280295_ graphe12352.png):
//       Permission denied in<b>/var/ www/ argos_dev/ thematics/ reports.php</b> on line <b>4426</ b><br/>{
export const generateReportClientSide = (
  payload: any
): Promise<GenerateReportClientSideResponse> => {
  return _post({
    request_type: requestType.generer_rapport_cote_client,
    ...payload,
  });
};
